"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = usePerformCardAction;

var _useWebChatAPIContext = _interopRequireDefault(require("./internal/useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function usePerformCardAction() {
  return (0, _useWebChatAPIContext.default)().onCardAction;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VQZXJmb3JtQ2FyZEFjdGlvbiIsInVzZVdlYkNoYXRBUElDb250ZXh0Iiwib25DYXJkQWN0aW9uIl0sInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaG9va3MvdXNlUGVyZm9ybUNhcmRBY3Rpb24udHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgUGVyZm9ybUNhcmRBY3Rpb24gfSBmcm9tICcuLi90eXBlcy9DYXJkQWN0aW9uTWlkZGxld2FyZSc7XG5pbXBvcnQgdXNlV2ViQ2hhdEFQSUNvbnRleHQgZnJvbSAnLi9pbnRlcm5hbC91c2VXZWJDaGF0QVBJQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZVBlcmZvcm1DYXJkQWN0aW9uKCk6IFBlcmZvcm1DYXJkQWN0aW9uIHtcbiAgcmV0dXJuIHVzZVdlYkNoYXRBUElDb250ZXh0KCkub25DYXJkQWN0aW9uO1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQ0E7Ozs7QUFFZSxTQUFTQSxvQkFBVCxHQUFtRDtFQUNoRSxPQUFPLElBQUFDLDZCQUFBLElBQXVCQyxZQUE5QjtBQUNEIn0=